import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { KEYS_CHARCODE } from "./../../../editor-common/index.js";
import { defaultSize, sizeMap } from "../../buttons/NodeSizeButton/consts.js";
import { ListItemSelect } from "../ListItem/index.js";
import DropdownModal from "./DropdownModal.js";
const SizePanel = ({ getSelectedSize, onClick, options }) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const OPTIONS = options ? options.map((option) => sizeMap[option]) : defaultSize;
  const onKeyDown = (e, commandKey) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick(commandKey);
      e.stopPropagation();
    }
  };
  const DropdownOptions = OPTIONS.map(({ dataHook, icon: Icon, text, commandKey, tooltip }) => /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      key: commandKey,
      dataHook,
      prefix: /* @__PURE__ */ React.createElement(Icon, null),
      title: t(text),
      selected: commandKey === getSelectedSize(),
      onKeyDown: (e) => {
        onKeyDown(e, commandKey);
      },
      tooltip: t(tooltip),
      onClick: () => onClick(commandKey)
    }
  ));
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};
var SizePanel_default = SizePanel;
export {
  SizePanel_default as default
};
//# sourceMappingURL=SizePanel.js.map
